export const ContactSearchTypes = {
  INDIVIDUAL: 'individual',
  BOTH: 'both',
  COMPANY: 'company'
}

export const isCompany = (type) => {
  return [ContactSearchTypes.COMPANY, ContactSearchTypes.BOTH].includes(type);
}
export const isIndividual = (type) => {
  return [ContactSearchTypes.INDIVIDUAL, ContactSearchTypes.BOTH].includes(type);
}


export const contactSearchGetters = type => {
  return {
    isCompany: isCompany(type),
    isIndividual: isIndividual(type)
  };
}
